window.mcb.links = window.mcb.links || {};
window.mcb.links.pageNavigation = (function () {
  const _logger = window.mcb.utilities.createLogger('links.pageNavigation');

  const fillWordsMaxLength = 3;
  const maxLineLength = 50;

  const reduceText = function (text, char, includeChar = true) {
    if (text.indexOf(char) > 0) {
      text = text.substring(0, includeChar ? text.indexOf(char) + char.length : text.indexOf(char)).trim();
    }

    return text;
  }

  const extractWords = function (text) {
    const parts = text.split(' ');
    text = '';
    let last = '';
    for (let part of parts) {
      if (text.length + part.length < maxLineLength) {
        text += ' ' + part;
        last = part;
      }
      else if (last.length <= fillWordsMaxLength) {
        return text.substring(0, text.length - last.length).trim() + '...';
      }
      else {
        return text.trim() + '...';
      }
    }
  }

  document.querySelectorAll('.mcb-link-collection-block--type--page-navigation').forEach((nav) => {
    const links = document.querySelectorAll('main a[id],.mcb-media-spot-block[id],.mcb-webpart--rte[id]');
    const compiled = [];
    links.forEach((link) => {
      if (link.id !== null && link.id !== '') {
        if (link.dataset.mcbAnchorManual === 'false') {
          _logger.trace(`  Skipping link with id "${link.id}" because it has mcbAnchorManual set to false.`);
          return;
        }

        if (link.dataset.mcbAnchorHide === 'true') {
          _logger.trace(`  Skipping link with id "${link.id}" because it has mcbAnchorHide set to true.`);
          return;
        }

        if (link.dataset.mcbAnchorText !== undefined && link.dataset.mcbAnchorText !== '') {
          _logger.trace(`  New Page Navigation Target with Custom Anchor Text "${link.id}": "${link.dataset.mcbAnchorText}".`);
          compiled.push({
            id: link.id,
            text: link.dataset.mcbAnchorText
          });

          return;
        }

        let text = link.innerText;
        if (link.classList.contains('mcb-webpart')) {
          let heading = link.querySelector('h1,h2') ?? link.querySelector('h3,h4');
          if (heading !== null) {
            text = heading.innerText;
          }
        }
        else if (link.innerText !== null && link.innerText.trim() === '') {
          text = link.parentNode.innerText.split('\n')[0];
        }

        if (text !== null && text.length > 0) {
          if (text.length > maxLineLength) {
            text = reduceText(text, '.');
          }

          if (text.length > maxLineLength) {
            text = reduceText(text, '?');
          }

          if (text.length > maxLineLength) {
            text = reduceText(text, '!');
          }

          if (text.length > maxLineLength) {
            text = reduceText(text, ':', false);
          }

          if (text.length > maxLineLength) {
            text = reduceText(text, ';', false);
          }

          if (text.length > maxLineLength) {
            text = reduceText(text, '-', false);
          }

          if (text.length > maxLineLength) {
            text = extractWords(text);
          }

          _logger.trace(`  New Page Navigation Target: "${text}"`);
          compiled.push({
            id: link.id,
            text: text
          });
        }
      }
    });

    if (compiled.length > 0) {
      const ul = document.createElement('ul');
      ul.role = "list";
      compiled.forEach((link) => {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = '#' + link.id;
        a.innerText = link.text;
        li.appendChild(a);
        ul.appendChild(li);
      });

      nav.appendChild(ul);
    }
  });
})();
